import React from 'react';

type CopyActionIconProps = {
  className?: string;
};

export default function CopyActionIcon({ className }: CopyActionIconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="16"
      viewBox="0 0 36 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="14"
        y="8"
        width="10"
        height="12"
        rx="1.5"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12H24.5C25.3284 12 26 12.6716 26 13.5V22.5C26 23.3284 25.3284 24 24.5 24H17.5C16.6716 24 16 23.3284 16 22.5V20"
        stroke="#213F39"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
